import { ValidationResult, Validator } from './interfaces';

export const EnpValidator: Validator = class {
    /**
     * Проверка контрольной суммы
     */
    private static checkSum(value: string, checkSum: number) {
        // выбираются нечетные цифры по порядку, начиная справа, в виде числа, и умножается это число на 2.
        // выбираются четные цифры по порядку, начиная справа, в виде числа, и результат приписывается слева от числа, полученного в пункте а)
        // складываются все цифры полученного в пункте б) числа.

        let a = 0;
        for (let i = value.length - 1; i >= 0; i -= 2) {
            a = a * 10 + Number(value[i]);
        }
        let v = 0;
        for (const c of String(a * 2).split(''))
            v += Number(c);

        // сразу начинаем складывать пункт б), так как в промежуточном результате нет смысла
        for (let i = value.length - 2; i > 0; i -= 2) {
            v += Number(value[i]);
        }

        const g = (10 - v % 10) % 10;

        return checkSum === g;
    }

    static validate(enp: string): ValidationResult {
        const formatValid = /[\d\s]/.test(enp);
        if (!formatValid)
            return { valid: false };
        const refinedValue = enp.replace(/\D+/g, '');
        if (refinedValue.length !== 16)
            return { valid: false };
        const valid = this.checkSum(
            refinedValue.slice(0, 15),
            Number(refinedValue.slice(15))
        );
        return {
            valid,
            refinedValue
        };
    }
}